/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formverification_Error1Inputs */

const ja_contact_formverification_error1 = /** @type {(inputs: Contact_Formverification_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証を完了できませんでした。ページを再読み込みするか、広告ブロッカーを無効にしてお試しください。`)
};

const en_contact_formverification_error1 = /** @type {(inputs: Contact_Formverification_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't verify you. Please reload the page, or disable your ad blocker and try again.`)
};

/**
* | output |
* | --- |
* | "We couldn't verify you. Please reload the page, or disable your ad blocker and try again." |
*
* @param {Contact_Formverification_Error1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formverification_error1 = /** @type {((inputs?: Contact_Formverification_Error1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formverification_Error1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formverification_error1(inputs)
	return en_contact_formverification_error1(inputs)
});
export { contact_formverification_error1 as "contact_formVerification_error" }